export { default as PhoneField, getPhoneFieldLabel } from './PhoneField';
export type { PhoneFieldData, PhoneFieldProps } from './PhoneField';
export {
  PHONE_REQUIRED_FLAG,
  isPhoneRequiredTreatment,
  usePhoneRequiredVariant,
} from './usePhoneRequiredVariant';
